export const OPEN_DOCUMENT_SELECTION_MODAL = 'OPEN_DOCUMENT_SELECTION_MODAL';
export const CLOSE_DOCUMENT_SELECTION_MODAL = 'CLOSE_DOCUMENT_SELECTION_MODAL';
export const FETCH_PROJECT_FOLDERS = 'FETCH_PROJECT_FOLDERS';
export const FETCH_FOLDER_CONTENTS = 'FETCH_FOLDER_CONTENTS';
export const CREATE_ATTACHMENT_FOR_CREATE = 'CREATE_ATTACHMENT_FOR_CREATE';
export const CREATE_ATTACHMENT_FROM_DOCUMENT = 'CREATE_ATTACHMENT_FROM_DOCUMENT';
export const CREATE_ATTACHMENT_FROM_DOCUMENT_START = 'CREATE_ATTACHMENT_FROM_DOCUMENT_START';
export const UPLOAD_ATTACHMENT_FILE_START = 'UPLOAD_ATTACHMENT_FILE_START';
export const ATTACHMENT_UPLOAD_FINISHED = 'ATTACHMENT_UPLOAD_FINISHED';
export const ATTACHMENT_UPLOAD_FAILED = 'ATTACHMENT_UPLOAD_FAILED';
export const CANCEL_ATTACHMENT_UPLOAD = 'CANCEL_ATTACHMENT_UPLOAD';
export const ATTACHMENT_CREATE_API = 'ATTACHMENT_CREATE_API';
export const ATTACHMENT_CREATE_API_FULFILLED = 'ATTACHMENT_CREATE_API_FULFILLED';
export const ATTACHMENT_DELETE_API = 'ATTACHMENT_DELETE_API';
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT';
export const ATTACHMENT_DELETE_API_FULFILLED = 'ATTACHMENT_DELETE_API_FULFILLED';
export const ATTACHMENT_DELETE_API_REJECTED = 'ATTACHMENT_DELETE_API_REJECTED';
export const HANDLE_OPEN_ATTACHMENT = 'HANDLE_OPEN_ATTACHMENT';
export const ATTACHMENT_CREATE_API_REJECTED = 'ATTACHMENT_CREATE_API_REJECTED';
export const OPEN_ATTACHMENT = 'OPEN_ATTACHMENT';
export const FIELD_ISSUES_ACTIVITY_FETCH_ATTACHMENTS = 'FIELD_ISSUES_ACTIVITY_FETCH_ATTACHMENTS';
export const DOCUMENT_THUMBNAIL_URL = 'DOCUMENT_THUMBNAIL_URL';
export const DOCUMENT_THUMBNAIL_URL_START = 'DOCUMENT_THUMBNAIL_URL_START';
export const DOCUMENT_THUMBNAIL_URL_FULFILLED = 'DOCUMENT_THUMBNAIL_URL_FULFILLED';
export const CLEAR_ALL_THUMBNAILS = 'CLEAR_ALL_THUMBNAILS';
export const UPDATE_UPLOAD_ATTACHMENTS_PROGRESS = 'UPDATE_UPLOAD_ATTACHMENTS_PROGRESS';
export const CLEAR_FAILED_UPLOADING_ATTACHMENTS = 'CLEAR_FAILED_UPLOADING_ATTACHMENTS';
export const CLEAR_UPLOADING_ATTACHMENTS_BY_ORIGIN = 'CLEAR_UPLOADING_ATTACHMENTS_BY_ORIGIN';
export const SHOW_ATTACHMENTS_IN_GALLERY = 'SHOW_ATTACHMENTS_IN_GALLERY';
export const CLOSE_GALLERY = 'CLOSE_GALLERY';

export const openDocumentSelectionModal = () => {
  return {
    type: OPEN_DOCUMENT_SELECTION_MODAL,
  };
};

export const closeDocumentSelectionModal = () => {
  return {
    type: CLOSE_DOCUMENT_SELECTION_MODAL,
  };
};

export const fetchProjectFolders = (resolve, reject) => {
  return {
    type: FETCH_PROJECT_FOLDERS,
    payload: {
      resolve,
      reject,
    },
  };
};

export const fetchFolderContents = (urn, options, resolve, reject) => {
  return {
    type: FETCH_FOLDER_CONTENTS,
    payload: {
      urn,
      options,
      resolve,
      reject,
    },
  };
};

export const createAttachmentForCreate = (attachment) => {
  return {
    type: CREATE_ATTACHMENT_FOR_CREATE,
    payload: {
      attachment,
    },
  };
};

export const createAttachmentFromDocument = (document, issueId, origin) => {
  return {
    type: CREATE_ATTACHMENT_FROM_DOCUMENT,
    payload: {
      document,
      issueId,
      origin,
    },
  };
};

export const uploadAttachmentFileStart = (fileId, name, issueId, origin) => {
  return {
    type: UPLOAD_ATTACHMENT_FILE_START,
    payload: {
      fileId,
      id: fileId,
      name,
      issueId,
      origin,
    },
  };
};

export const uploadAttachmentFinished = (issueId, document, fileId, createAfterUpload, origin) => {
  return {
    type: ATTACHMENT_UPLOAD_FINISHED,
    meta: { id: issueId, fileId, createAfterUpload, origin },
    payload: document,
  };
};

export const uploadAttachmentFailed = (fileId) => {
  return {
    type: ATTACHMENT_UPLOAD_FAILED,
    payload: {
      fileId,
    },
  };
};

export const cancelAttachmentUpload = (fileId) => {
  return {
    type: CANCEL_ATTACHMENT_UPLOAD,
    payload: {
      fileId,
    },
  };
};

export const openAttachmentAction = (attachment) => {
  return {
    type: HANDLE_OPEN_ATTACHMENT,
    payload: {
      urn: attachment.urn,
      urnType: attachment.urnType,
      name: attachment.name,
      createdBy: attachment.createdBy,
    },
  };
};

export const showAttachmentsInGallery = (attachments, selectedIndex = 0) => {
  return {
    type: SHOW_ATTACHMENTS_IN_GALLERY,
    payload: {
      selectedIndex,
      attachments,
    },
  };
};

export const closeGallery = () => {
  return {
    type: CLOSE_GALLERY,
  };
};

export const setDocumentThumbnailUrlPromiseAction = (thumbnailPromise) => {
  return {
    type: DOCUMENT_THUMBNAIL_URL,
    payload: thumbnailPromise,
  };
};

export const clearAllThumbnails = () => {
  return {
    type: CLEAR_ALL_THUMBNAILS,
  };
};

export const updateUploadAttachmentProgress = (fileId, progress) => {
  return {
    type: UPDATE_UPLOAD_ATTACHMENTS_PROGRESS,
    payload: {
      fileId,
      progress,
    },
  };
};

export const clearFailedUploadingAttachments = () => {
  return {
    type: CLEAR_FAILED_UPLOADING_ATTACHMENTS,
  };
};

export const clearUploadingAttachmentsListByOrigin = (origin) => {
  return {
    type: CLEAR_UPLOADING_ATTACHMENTS_BY_ORIGIN,
    payload: origin,
  };
};

export const deleteAttachmentAction = (issueId, attachmentId, analyticsObj) => {
  return {
    type: DELETE_ATTACHMENT,
    payload: {
      issueId,
      attachmentId,
      analyticsObj,
    },
  };
};

export const fieldIssuesActivityFetchAttachments = (attachments) => {
  return {
    type: FIELD_ISSUES_ACTIVITY_FETCH_ATTACHMENTS,
    payload: attachments,
  };
};
